export default __webpack_public_path__ + "static/media/periodico.b55ed25b.png";